export default __webpack_public_path__ + "static/media/timeline-horizontal.4c020508.png";